<template>
  <div class="main">
    <div class="options">
      <div class="filters-and-table-box-controls">
        <div class="filters-summary-container">
          <span>{{ filterText }}</span>
        </div>
        <ButtonFilter
          buttonText="Change Filter"
          filterPosition="right"
          :filterWidth="420"
          :isOpen.sync="mainFilterIsOpen"
        >
          <div class="button-filter-content-container">
            <BoxContainer
              class="date-filter-container"
              :title="`Delivery Note Date`"
              :isCheckBox="true"
              :isChecked.sync="dateFilterChecked"
            >
              <DateTimePicker
                :placeholder="`Start`"
                :value.sync="fromDatePicker"
                :showTime="false"
                :isDisabled="!dateFilterChecked"
              />
              <DateTimePicker
                :placeholder="`End`"
                :value.sync="toDatePicker"
                :showTime="false"
                :isDisabled="!dateFilterChecked"
              />
            </BoxContainer>

            <BoxContainer
              class="booking-no-filter-container"
              title="Search"
              :isChecked.sync="searchFilterChecked"
              :isCheckBox="true"
              style="margin-bottom: 5px"
            >
              <Dropdown
                placeholder="Search By"
                :items="searchFilterItems"
                itemKey="Search Criteria"
                :isDisabled="!searchFilterChecked"
                :isRequired="searchFilterChecked"
                :selectedObject.sync="selectedSearchBy"
                :errorMessage.sync="searchByError"
                @selected="searchBySelected"
                validator="text,40"
              />
              <Dropdown
                placeholder="Search Criteria"
                :items="searchCriteriaItems"
                itemKey="name"
                :isDisabled="!searchFilterChecked || criteriaDisabled"
                :isRequired="searchFilterChecked"
                :selectedObject.sync="selectedCriteria"
                validator="text,40"
              />
              <Input
                placeholder="Search"
                :inputValue.sync="searchByValue"
                :isDisabled="!searchFilterChecked"
                :isRequired="searchFilterChecked"
                :errorMessage.sync="searchByValueError"
              />
            </BoxContainer>
            <div class="refresh-button-container">
              <button @click="refreshFilterClicked" :disabled="!dateFilterChecked && !searchFilterChecked">
                Refresh
              </button>
            </div>
          </div>
        </ButtonFilter>
      </div>

      <div class="table-box-container">
        <TableBox
          :tableData="printList"
          title="Delivery Note"
          :selectedRow.sync="selectedDN"
          :loading="tableLoading"
          :selectedIndex="selectedIndex"
        />
      </div>
      <div class="call-to-action-buttons">
        <button @click="previewClicked">Preview Report</button>
      </div>
    </div>
    <div class="report-preview">
      <DesignerV2
        v-if="showDesignerV3 && pagerData"
        :viewMode="true"
        :reportData="pagerData"
        reportFolder="ROTForm"
        :reportFile="designerV3ReportFiles"
        :canShare="true"
        :canClose="false"
      />

      <div v-else class="user-instructions">
        <span>Select Delivery Note and click on <strong>Preview Report</strong> to get started</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  components: {},
  data: function () {
    return {
      dnno: '',
      userid: '',
      configCode: '',

      user: '',

      reportShareDetails: {},

      pagerData: null,
      showDesignerV3: true,
      selectedIndex: [],
      routeWithDN: false,
      mainFilterIsOpen: false,
      dateFilterChecked: true,
      searchFilterChecked: false,
      fromDatePicker: new Date(new Date().setDate(new Date().getDate() - 3)),
      toDatePicker: new Date(),
      searchFilterItems: [],
      searchCriteriaItems: [{ name: 'EQUALS' }, { name: 'STARTS WITH' }, { name: 'CONTAINS' }, { name: 'ENDS WITH' }],
      selectedSearchBy: null,
      criteriaDisabled: false,
      selectedCriteria: null,
      searchByValue: '',
      searchByError: '',
      searchByValueError: '',
      filterText: '',
      printList: [],
      selectedDN: [],
      tableLoading: false,
      designerV3ReportFiles: ['DeliveryNote_General.json'], // default
    };
  },
  props: {},
  methods: {
    searchBySelected: function (e) {
      if (e) {
        if (e['Search Criteria'] == 'Required Date') {
          this.selectedCriteria = this.searchCriteriaItems[0];
          this.criteriaDisabled = true;
        } else {
          this.criteriaDisabled = false;
        }
      }
    },
    refreshFilterClicked: async function () {
      this.printList = [];
      this.dnno = '';
      this.selectedDN = [];
      this.searchByError = '';
      this.searchByValueError = '';

      if (this.searchFilterChecked && (!this.selectedSearchBy || !this.searchByValue)) {
        this.searchByError = !this.selectedSearchBy ? 'Please select your search criteria' : '';
        this.searchByValueError = !this.searchByValue ? 'Please enter your search value' : '';
        return;
      }
      const dataToPost = {
        startdate: this.dateFilterChecked ? new Date(this.fromDatePicker).formatString('yyyy-MM-dd') : '',
        enddate: this.dateFilterChecked ? new Date(this.toDatePicker).formatString('yyyy-MM-dd') : '',
        searchfield: this.searchFilterChecked ? this.selectedSearchBy['Search Criteria'] : '',
        searchcriteria: this.searchFilterChecked ? this.selectedCriteria['name'] : '',
        searchvalue: this.searchFilterChecked ? this.searchByValue : '',
      };

      if (this.dateFilterChecked && this.searchFilterChecked) {
        this.filterText = `Filter by ${this.selectedSearchBy['Search Criteria']} ${this.selectedCriteria['name']} ${this.searchByValue}, from ${new Date(this.fromDatePicker).formatString('yyyy-MM-dd')} to ${new Date(this.toDatePicker).formatString('yyyy-MM-dd')}`;
      } else if (this.dateFilterChecked && !this.searchFilterChecked) {
        this.filterText = `Filter by date from ${new Date(this.fromDatePicker).formatString('yyyy-MM-dd')} to ${new Date(this.toDatePicker).formatString('yyyy-MM-dd')}`;
      } else if (!this.dateFilterChecked && this.searchFilterChecked) {
        this.filterText = `Filter by ${this.selectedSearchBy['Search Criteria']} ${this.selectedCriteria['name']} ${this.searchByValue}`;
      }
      //console.log(dataToPost);

      this.$fullscreenLoading('Getting Delivery Note');
      this.printList = await this.$apiCallV2('/DeliveryNotes/GetDeliveryNoteListing', dataToPost);
      this.lastRefreshed = new Date().formatString('yyyy-MM-dd HH:mm:ss');
      this.printList = this.printList.map((item) => {
        if (item.Remarks && typeof item.Remarks === 'string') {
          // weishen 20240426 - replace all newline characters with <br> only in the Remarks field
          item.Remarks = item.Remarks.replace(/\n/g, '<br>');
        }
        if (item['Goods Description'] && typeof item['Goods Description'] === 'string') {
          item['Goods Description'] = item['Goods Description'].replace(/\n/g, '<br>');
        }
        if (item['Shipping Marks'] && typeof item['Shipping Marks'] === 'string') {
          item['Shipping Marks'] = item['Shipping Marks'].replace(/\n/g, '<br>');
        }
        return item;
      });
      this.lastRefreshed = new Date().formatString('yyyy-MM-dd HH:mm:ss');
      this.mainFilterIsOpen = false;
      this.$fullscreenLoading();
    },

    generateReport: async function () {
      this.showDesignerV3 = false;
      this.pagerData = []; //reset report data

      this.$fullscreenLoading('Getting Details');

      let dnDetails = [];

      const loginDetails = await this.$apiCallV2('/Login/GetDetails');

      if (this.user) {
        dnDetails = await this.$apiCallV2(`/DeliveryNotes/GetDeliveryNoteDetails?dnno=${this.dnno}`);
      } else {
        dnDetails = await this.$apiCallV2(
          `/DeliveryNotes/GetDeliveryNoteDetails?dnno=${this.dnno}&config=${this.configCode}&userid=${this.userid}`,
        );
      }

      if (dnDetails.length == 0) {
        this.$showAlert('error', 'Invalid Delivery Note #', `Please verify your DN # ${this.dnno} is correct`);
      } else {
        const data = dnDetails[0];
        if (data['ROTDate']) {
          data['ROTDate'] = new Date(data['ROTDate']).formatString(this.$store.state['preferredDateFormat']);
        }
        if (data['Date_ETA']) {
          data['Date_ETA'] = new Date(data['Date_ETA']).formatString(this.$store.state['preferredDateFormat']);
        }

        data['companyHeader'] = loginDetails.CoHeaderOpr ? loginDetails.CoHeaderOpr : '';
        data['companyName'] = loginDetails.CoName ? loginDetails.CoName : '';
        data['getNowDateTime'] = this.$dateTime.getDateTime(new Date(), 'dd/MM/yyyy HH:mm');

        //calculate total quantity
        data['totalQuantity'] = (data['PackingList'] || []).reduce((sum, row) => {
          return sum + Number(row['SubPackages Qty'] || 0);
        }, 0);

        //qr code
        const qrDetail = `{"DNNO":"${data['ROTNo']}"} `;
        data['QR'] = await this.$getQRURL(qrDetail, { size: 150, margin: 10 });

        //reformat address
        const addressFrom = [
          data.FromAdd1,
          data.FromAdd2,
          data.FromAdd3,
          data.FromAdd4,
          [data.FromPostCode, data.FromCity].filter(Boolean).join(' '),
          [data.FromState, data.FromCountry].filter(Boolean).join(' '),
        ];
        const addressTo = [
          data.ToAdd1,
          data.ToAdd2,
          data.ToAdd3,
          data.ToAdd4,
          [data.ToPostCode, data.ToCity].filter(Boolean).join(' '),
          [data.ToState, data.ToCountry].filter(Boolean).join(' '),
        ];

        // remove empty / null / undefined lines
        data.FromAdd = addressFrom.filter((line) => line && line.toString().trim() !== '').join('\n');
        data.ToAdd = addressTo.filter((line) => line && line.toString().trim() !== '').join('\n');

        //this.$refs['report'].generateReport('BJl6F_jNVD', data);
        this.pagerData = data;
        //console.log(this.pagerData);
        this.showDesignerV3 = true;
      }

      this.$fullscreenLoading();
    },
    refreshListing: async function () {
      let dataToPost = {};
      if (this.routeWithDN == false) {
        dataToPost = {
          startdate: this.dateFilterChecked ? new Date(this.fromDatePicker).formatString('yyyy-MM-dd') : '',
          enddate: this.dateFilterChecked ? new Date(this.toDatePicker).formatString('yyyy-MM-dd') : '',
          searchfield: this.searchFilterChecked ? this.selectedSearchBy['Search Criteria'] : '',
          searchcriteria: this.searchFilterChecked ? this.selectedCriteria['name'] : '',
          searchvalue: this.searchFilterChecked ? this.searchByValue : '',
        };
      } else {
        dataToPost = {
          searchfield: 'Delivery Note #',
          searchcriteria: 'EQUALS',
          searchvalue: this.dnno,
        };
        this.selectedSearchBy = this.searchFilterItems.find((item) => item['Search Criteria'] == 'Delivery Note #');
        this.selectedCriteria = this.searchCriteriaItems.find((item) => item['name'] == 'EQUALS');
        this.searchByValue = this.dnno;
      }
      this.tableLoading = true;
      this.$fullscreenLoading('Getting Delivery Note Details');

      //reset to empty
      this.printList = [];
      this.selectedDN = [];

      //call api
      this.printList = await this.$apiCallV2(`/DeliveryNotes/GetDeliveryNoteListing`, dataToPost);
      this.tableLoading = false;

      if (this.printList.length > 0) {
        // Find the index of the booking that matches `dnno`
        const index = this.printList.findIndex((item) => item['Delivery Note #'] === this.dnno);

        if (index !== -1) {
          this.$nextTick(() => {
            this.selectedDN = [this.printList[index]]; // Select the record
            this.selectedIndex = [index]; // Using this prop to highlight the row in TableBox, because the above code doesn't work
          });
        }
      }

      this.$fullscreenLoading();
    },
    previewClicked: function () {
      this.mainFilterIsOpen = false;
      if (this.selectedDN.length == 0) {
        this.$showAlert('error', 'No Delivery Note Selected', `Please select a record to print Delivery Note`);
      } else {
        this.dnno = this.selectedDN[0]['Delivery Note #'].trim();
        this.generateReport();
      }
    },
  },
  async mounted() {
    this.searchFilterItems = await this.$apiCallV2('/Master/GetListMaster', {
      masterfile: 'JOBQUERY',
      module: 'CONTLESS',
    });
    const query = this.$route.query;
    const params = this.$route.params;

    if (query['dn']) {
      this.dnno = query['dn'];
    }
    if (query['userid']) {
      this.userid = query['userid'];
    }
    if (query['config']) {
      this.configCode = query['config'];
    }

    if (params['user']) {
      this.user = params['user'];
    }

    this.reportShareDetails['subject'] = `Delivery Note Report - ${this.dnno}`;
    this.reportShareDetails['body'] =
      `Your Delivery Note Report for Delivery Note # ${this.dnno} is available at {link}`;

    if (this.dnno) {
      this.generateReport();
    }

    if (this.dnno) {
      this.routeWithDN = true;

      this.dateFilterChecked = false;
      this.searchFilterChecked = true;
      this.searchByValue = this.dnno;

      await this.refreshListing();
    } else {
      this.dnno = '';
      this.routeWithDN = false;
      this.refreshFilterClicked();
    }

    if (!this.selectedSearchBy) {
      this.selectedSearchBy = this.searchFilterItems[0];
    }

    if (!this.selectedCriteria) {
      this.selectedCriteria = this.searchCriteriaItems[2];
    }

    // Fetch the report name if available in settingssytem
    const res = await this.$apiCallV2('/Master/GetSettingsSystem?settingsitem=DN_DNReport');
    const settingValue = res?.[0]?.SettingsValue;
    if (settingValue) {
      this.designerV3ReportFiles = [settingValue];
    }
  },
  watch: {},
  computed: {},
};
</script>

<style lang="scss" scoped>
@import '@/css/all.scss';

.main {
  font-size: 12px;
  width: 100%;
  height: 100%;
  padding: 10px 45px;
  display: flex;
  overflow: hidden;

  > .options {
    margin-right: 2.5px;
    flex: 1;
    background-color: white;
    padding: 5px;
    width: 50%;
    overflow-y: auto;
    height: 100%;

    > .table-box-container {
      height: 90%;
    }

    > .details-block {
      display: flex;
      width: 100%;
      position: relative;
      margin-bottom: 2px;

      > .details-column {
        width: calc(100% / 3);
        margin-right: 5px;
      }
    }

    > .filters-and-table-box-controls {
      display: flex;
      flex-direction: row;
      justify-content: flex-end;
      margin-bottom: 5px;

      > .filters-summary-container {
        margin-right: 5px;
        align-content: center; // vertically align the summary text
        text-align: end; // horizontally align the summary text
      }

      .button-filter-content-container {
        text-align: left;
        cursor: auto;

        .no-filter-container {
          margin-top: 15px;
        }

        .customer-filter-container {
          margin-top: 15px;
        }

        .outstanding-and-job-type-filters {
          display: flex;
          flex-direction: row;

          > .outstanding-dropdown {
            margin-right: 5px;
          }

          > .job-type-dropdown {
            margin-left: 5px;
          }
        }

        .not-printed-filter {
          margin-top: 5px;
          display: flex;
          justify-content: flex-start;
        }

        .refresh-button-container {
          margin-top: 10px;
          display: flex;
          justify-content: flex-end;
        }
      }

      > .select-deselect-all-button {
        margin-left: 5px;
      }
    }
  }

  > .report-preview {
    margin-left: 2.5px;
    flex: 1;
    background-color: white;
    padding: 5px;

    > .user-instructions {
      height: 100%;
      display: flex;
      text-align: center;
      justify-content: center;
      align-items: center;
      font-size: 20px;
    }
  }

  .call-to-action-buttons {
    display: flex;
    margin-top: 10px;
    justify-content: flex-end;
  }

  .call-to-action-buttons > .format-dropdown {
    display: flex;
    align-items: center;
    gap: 5px;
    width: 50%;
  }

  .popup-details {
    display: block;
    height: 100%;
  }
  .tab-block {
    display: flex;
    width: 100%;
    border: 1px solid rgba(0, 0, 0, 0.5);
    margin-top: 10px;
    margin-bottom: 10px;
    position: relative;
    padding-top: 10px;
    padding-left: 5px;

    > .tab-title {
      width: fit-content;
      background-color: white;
      position: absolute;
      top: -10px;
      left: 10px;
      padding: 0 10px;
    }

    > .details-column {
      width: 100%;
      margin-right: 5px;
    }
  }
}
</style>
